import 'babel-polyfill'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()
require('es6-promise').polyfill()
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './mixin'


/* 公共样式 */
import "./assets/css/global.less"

import 'amfe-flexible'

import { Button, DropdownMenu, DropdownItem, Col, Row, Field, Image as VanImage, Popup, Calendar, Icon, NavBar, Skeleton, Toast, PullRefresh, Tab, Tabs, Checkbox, Divider, Collapse, CollapseItem } from 'vant'

Vue.use(Button).use(DropdownMenu).use(DropdownItem).use(Col).use(Row).use(Field).use(VanImage).use(Popup).use(Calendar).use(Icon).use(NavBar).use(Skeleton).use(Toast).use(PullRefresh).use(Tab).use(Tabs).use(Checkbox).use(Divider).use(Collapse).use(CollapseItem)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')